<template>
  <div>
    <v-btn @click="$router.go(-1)"> Back </v-btn>
    <v-btn @click="print"> Print </v-btn>
    <router-view/>
  </div>
</template>

<script>
import Alerts from '@/components/info/Alerts'
export default {
  components: {
    Alerts
  },
  methods: {
    print () {
      let css = {
        orientation: 'portrait',
        additional: ''
      }
      if (this.$route.name === 'printGatePass' || this.$route.name === 'printParking') {
        css.orientation = 'landscape'
        css.additional = 'html, body, .container { height:100%; overflow: hidden !important;}'
      }
      // replace the css
      document.getElementById('printStyle').innerHTML = '@page { size: ' + css.orientation + ';} ' + css.additional
      window.print()
    }
  }
}
</script>

<style>
@media print {
  nav, aside, .v-btn {
    display: none !important;
  }
  main {
    padding: 0 !important;
  }
  html, body, .container {
    overflow: auto;
    height: auto;
    margin: 0 !important;
    padding: 0 !important;
  }
  @page {
    margin:1cm;
  }
  .scroll-y {
     height: auto;
     overflow: visible;
  }
  .scroll-x {
     height: auto;
     overflow: visible;
  }
}
</style>
